const QUERIES = {
  USERS_LIST: 'users-list',
  ORGANIZATIONS_LIST: 'organizations-list'
}

export { QUERIES }
